import { render, staticRenderFns } from "./theme-2.vue?vue&type=template&id=e8bdce24"
import script from "./theme-2.vue?vue&type=script&lang=js"
export * from "./theme-2.vue?vue&type=script&lang=js"
import style0 from "./theme-2.vue?vue&type=style&index=0&id=e8bdce24&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsChangeLanguageLoading: require('/app/components/Commons/ChangeLanguageLoading.vue').default,Theme2OfflinePage: require('/app/components/Theme2/OfflinePage.vue').default,Theme2ImageBackground: require('/app/components/Theme2/ImageBackground.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default,CommonsLiveChat: require('/app/components/Commons/LiveChat.vue').default})
